import React from 'react';
import { Box, Container, Paper, Stack, Typography, Alert } from '@mui/material';
import MainLayout from '../../../components/layout/MainLayout';

const IDCardsPage: React.FC = () => {
  return (
    <MainLayout>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Stack spacing={2} sx={{ mb: 3 }}>
          <Box>
            <h2 style={{ margin: 0 }}>Staff ID Cards</h2>
            <p style={{ margin: '4px 0 0 0', color: '#666', fontSize: '14px' }}>Generate, preview, and bulk export staff ID cards</p>
          </Box>
        </Stack>

        <Paper sx={{ p: 3 }}>
          <Alert severity="info">
            The ID card generation engine uses templates with placeholders: #STAFFNAME#, #EMPLOYEECODE#, #DEPARTMENT#, #DESIGNATION#, #PHOTO#
          </Alert>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Features coming soon:
            <ul>
              <li>Preview staff ID cards</li>
              <li>Bulk PDF export</li>
              <li>Customize templates</li>
              <li>Print-ready layouts</li>
            </ul>
          </Typography>
        </Paper>
      </Container>
    </MainLayout>
  );
};

export default IDCardsPage;
